import { render } from "./MainCarosel.vue?vue&type=template&id=0cec0aa4&scoped=true"
import script from "./MainCarosel.vue?vue&type=script&lang=js"
export * from "./MainCarosel.vue?vue&type=script&lang=js"

import "./MainCarosel.vue?vue&type=style&index=0&id=0cec0aa4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cec0aa4"]])

export default __exports__